import React from 'react';
import { Link } from 'react-router-dom';

import Lazy from '../../../../components/lazy';

import * as S from './styles';

type Props = {
  className?: string;
  imageUrl?: string | null;
  pathName: string;
  preamble: string;
  title: string;
  linkText?: string;
};

const FeaturedArticle = ({
  className,
  imageUrl,
  pathName,
  preamble,
  title,
  linkText,
}: Props) => (
  <S.FeaturedArticle className={className}>
    {imageUrl && (
      <S.ImageWrapper>
        <Lazy loadOnIdle>
          <Link to={pathName}>
            <img src={imageUrl} alt="" />
          </Link>
        </Lazy>
      </S.ImageWrapper>
    )}
    <S.TextContainer>
      <h3>
        <Link to={pathName}>{title}</Link>
      </h3>

      <Link to={pathName}>
        <p>{preamble}</p>
      </Link>

      {linkText ? (
        <S.ArticleLink
          color="primary"
          variant="outlined"
          component={<Link to={pathName} />}
        >
          {linkText}
        </S.ArticleLink>
      ) : (
        []
      )}
    </S.TextContainer>
  </S.FeaturedArticle>
);

export default FeaturedArticle;
